import { issueToken } from 'src/firebaseCloud/moralis/issueToken';
import { requestMessage } from '../../firebaseCloud';

export async function getMessageToSign(account: string, chain: number) {
  const userData = {
    address: account,
    chain,
    networkType: 'evm',
  };
  try {
    const requestMessageResponse = await requestMessage(userData);
    //TODO: update types for requestMessage & issueToken
    const { data } = requestMessageResponse;
    return { error: false, message: data?.message };
  } catch (error) {
    return { error };
  }
}
type GetMoralisTokenParams = {
  message: string;
  signature: string;
};

export async function getMoralisToken({
  message,
  signature,
}: GetMoralisTokenParams) {
  const { data } = await issueToken({
    message,
    signature,
    networkType: 'evm',
  });
  return data.token;
}
